import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  Input,
  QueryList,
} from '@angular/core';
import { GridColumnHeaderComponent } from '../grid-column-header/grid-column-header.component';
import { GridColumnComponent } from '../grid-column/grid-column.component';

@Component({
  selector: 'app-grid-column-group',
  template: '',
  standalone: false,
})
export class GridColumnGroupComponent<T extends {}> implements AfterContentInit {
  @Input() headerName: string;
  @Input() set defaultOpen(value: boolean) {
    this.open = value;
  }

  @ContentChildren(GridColumnComponent, { descendants: true }) columns: QueryList<
    GridColumnComponent<T, any>
  >;
  @ContentChild(GridColumnHeaderComponent, { descendants: false })
  header?: GridColumnHeaderComponent;

  open = true;

  get headerTemplate() {
    return this.header?.template;
  }

  ngAfterContentInit() {
    this.columns.changes.subscribe(() => this.columns.forEach(c => (c.group = this)));
  }
}
